import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class LocalStorageService {
    public setItem(key: LocalStorageKey, value: unknown) {
        localStorage.setItem(key, JSON.stringify(value));
    }

    public setMap<K, V>(key: LocalStorageKey, map: Map<K, V>) {
        localStorage.setItem(key, JSON.stringify(Array.from(map.entries())));
    }

    public removeItem(key: LocalStorageKey) {
        localStorage.removeItem(key);
    }

    public removeAll() {
        localStorage.clear();
    }

    public getItem<T>(key: LocalStorageKey): T | null {
        const data = localStorage.getItem(key);
        return JSON.parse(data) as T | null;
    }

    public getMap<K, V>(key: LocalStorageKey): Map<K, V> | null {
        const data = localStorage.getItem(key);
        return new Map<K, V>(JSON.parse(data) as Map<K, V>);
    }
}

export enum LocalStorageKey {
    Language = 'language'
    //LeftFlyoutContent = 'left-flyout-content'
}
